import { useTranslation } from "react-i18next";
import type { BookingScheduleInterface } from "../../../../../features/Booking-Form/typings/booking.types";
import {
  resolveResourceBookingApprovalStatus,
  toTitleCaseStatus
} from "../../../../../features/Schedule/utils/resource-booking-schedule.utils";
import { ScheduleResourceBookingMetaField } from "./ScheduleResourceBookingMetaField.partial";

type ScheduleResourceBookingApprovalStatusProps = Readonly<{
  schedule: BookingScheduleInterface;
}>;

export function ScheduleResourceBookingApprovalStatus({
  schedule
}: ScheduleResourceBookingApprovalStatusProps) {
  const { t } = useTranslation();
  const approvalStatus = resolveResourceBookingApprovalStatus(schedule);

  if (approvalStatus == null) {
    return null;
  }

  return (
    <ScheduleResourceBookingMetaField
      label={t("Approval")}
      testId="schedule-resource-booking-approval-status"
    >
      {toTitleCaseStatus(t(approvalStatus))}
    </ScheduleResourceBookingMetaField>
  );
}
